/* eslint-disable no-unused-vars */


//i am trying get this to work to showthe icon and to the right size

import React from 'react';
import { useSelector } from 'react-redux';

import { MdOutlineRestaurantMenu } from "react-icons/md";
import { IoMdLogIn } from "react-icons/io";
import { FaUser } from "react-icons/fa";
import { RiLockPasswordFill } from 'react-icons/ri';


const SiteBadge = ({ iconType, iconSize, badgeSize }) => {  // ✅ Destructure from props object
    const { seller } = useSelector(state => state.seller);

    const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
    const sellerPrimaryColor2 = seller?.frontEndPrimaryColor2;
    const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

    const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
    const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';

    return (
        <div className='bg-transparent'>
            <div
                className='rounded-xl flex items-center justify-center flex-shrink-0 border-none border-black'
                style={{
                    backgroundColor: sellerSecondaryColor1 + sellerColorSuffixDark,
                    width: badgeSize + 'px',
                    height: badgeSize + 'px',
                    display: 'flex',           // ✅ Center the icon
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <MdOutlineRestaurantMenu className={`${iconType === 'Menu' ? '' : 'hidden'}`}
                    style={{
                        fontSize: iconSize + 'px', flexShrink: 0,
                        color: sellerPrimaryColor1 + sellerColorSuffixMedium,
                    }}
                />
                <IoMdLogIn className={`${iconType === 'Login' ? '' : 'hidden'}`}
                    style={{
                        fontSize: iconSize + 'px', flexShrink: 0,
                        color: sellerPrimaryColor1 + sellerColorSuffixMedium,
                    }}
                />
                <FaUser className={`${iconType === 'Register' ? '' : 'hidden'}`}
                    style={{
                        fontSize: iconSize + 'px', flexShrink: 0,
                        color: sellerPrimaryColor1 + sellerColorSuffixMedium,
                    }}
                />
                <RiLockPasswordFill className={`${iconType === 'ForgotPassword' ? '' : 'hidden'}`}
                    style={{
                        fontSize: iconSize + 'px', flexShrink: 0,
                        color: sellerPrimaryColor1 + sellerColorSuffixMedium,
                    }}
                />
            </div>
        </div>
    );
};

export default SiteBadge;



// import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// import { MdEmail, MdOutlineRestaurantMenu } from "react-icons/md";


// const SiteBadge = (iconType, iconSize, badgeSize) => {
//     const { seller } = useSelector(state => state.seller);

//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
//     const sellerPrimaryColor2 = seller?.frontEndPrimaryColor2;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
//     const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
//     return (
//         <div>
//             <div className='border border-black'
//             style={{ 
//                 backgroundColor: sellerSecondaryColor1 + sellerColorSuffixDark,
//                 width: badgeSize + 'px',
//                 height: badgeSize + 'px',
//             }}>
//             <MdOutlineRestaurantMenu style={{ fontSize: iconSize + 'px',  
//                 color: sellerPrimaryColor1 + sellerColorSuffixMedium}} />
//             </div>
//         </div>
//     );
// };

// export default SiteBadge;





    //  <div
    //                                     className='w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0'
    //                                     style={{ backgroundColor: sellerSecondaryColor1 + sellerColorSuffixDark ?? '#f0f4ff' }}>
    //                                     <MdOutlineRestaurantMenu className='text-[30px]' 
    //                                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
    //                                 </div>
    //<div className={` ${iconType === 'Menu' ? 'text-white' : 'text-black' } `}>
            // adwqweqwe
            
            // </div>
    //console.log(iconType, iconSize, badgeSize);
    //size={{iconSize}}
    //font-size: 40px;
    //width: iconSize + 'px', height: iconSize + 'px',
